// Eigene, schlichte Strich-Symbole (24er Raster). Keine fremden Icon-Sätze.
import type { SVGProps } from "react";
import globus from "../assets/globus.png";

const PFADE = {
  inbox: "M4 13l2.5-7h11L20 13M4 13v5h16v-5M4 13h5l1 2h4l1-2h5",
  leads: "M4 20V8l8-4 8 4v12M9 20v-5h6v5M8 10h.01M12 10h.01M16 10h.01",
  ansicht: "M4 6h16M4 12h10M4 18h6M17 15l3 3-3 3",
  opportunity: "M4 17l5-5 4 4 7-8M15 8h5v5",
  report: "M5 20V10M12 20V4M19 20v-7",
  einstellungen:
    "M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z",
  suche: "M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4",
  telefon: "M5 4h3l2 5-2 1a11 11 0 006 6l1-2 5 2v3a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z",
  abmelden: "M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10",
  sonne: "M12 17a5 5 0 100-10 5 5 0 000 10zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4",
  mond: "M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z",
  notiz: "M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h5",
  aufgabe: "M9 11l3 3 8-8M20 12v7a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h9",
  plus: "M12 5v14M5 12h14",
  "pfeil-rechts": "M5 12h14M13 6l6 6-6 6",
  "pfeil-links": "M19 12H5M11 6l-6 6 6 6",
  "pfeil-hoch": "M12 19V5M6 11l6-6 6 6",
  "pfeil-runter": "M12 5v14M6 13l6 6 6-6",
  schliessen: "M6 6l12 12M18 6L6 18",
  kopieren: "M9 9h11v11H9zM15 9V4H4v11h5",
  haken: "M5 12.5l4.5 4.5L19 7",
  kalender: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4",
  uhr: "M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 2",
  stift: "M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4",
  papierkorb: "M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6",
  filter: "M4 5h16l-6 8v6l-4-2v-4z",
  mail: "M3 6h18v12H3zM3 7l9 6 9-6",
  sms: "M4 5h16v11H9l-5 4z",
  meeting: "M3 7h12v10H3zM15 10l6-3v10l-6-3",
  status: "M4 12h11M11 7l5 5-5 5M20 5v14",
  aktivitaet: "M5 21V4M5 4h12l-2.5 4L17 12H5",
  person: "M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0",
  "neu-laden": "M20 11a8 8 0 10-2.3 5.7M20 4v7h-7",
  extern: "M14 4h6v6M20 4l-9 9M18 14v6H4V6h6",
  stecknadel: "M9 3h6l-1 6 4 4H6l4-4zM12 13v8",
  warnung: "M12 3l10 18H2zM12 10v5M12 18h.01",
  info: "M12 21a9 9 0 100-18 9 9 0 000 18zM12 11v6M12 7.5h.01",
  "chevron-unten": "M6 9l6 6 6-6",
  "chevron-rechts": "M9 6l6 6-6 6",
  "chevron-links": "M15 6l-6 6 6 6",
  "chevron-hoch": "M6 15l6-6 6 6",
  ausgehend: "M7 17L17 7M9 7h8v8",
  eingehend: "M17 7L7 17M15 17H7V9",
  tastatur: "M3 6h18v12H3zM7 10h.01M11 10h.01M15 10h.01M7 14h10",
  schloss: "M6 11h12v10H6zM8 11V8a4 4 0 018 0v3",
  erledigt: "M12 21a9 9 0 100-18 9 9 0 000 18zM8 12l3 3 5-6",
  angelegt: "M12 21a9 9 0 100-18 9 9 0 000 18zM12 8v8M8 12h8",
  zusammen: "M7 4v5a5 5 0 005 5h7M16 11l3 3-3 3M7 20v-6",
  sortieren: "M8 4v16M4 8l4-4 4 4M16 20V4M12 16l4 4 4-4",
  link: "M10 14a4 4 0 006 0l3-3a4 4 0 00-6-6l-1 1M14 10a4 4 0 00-6 0l-3 3a4 4 0 006 6l1-1",
  ort: "M12 21s7-6 7-11a7 7 0 00-14 0c0 5 7 11 7 11zM12 12a2 2 0 100-4 2 2 0 000 4z",
  text: "M4 6h16M4 12h16M4 18h10",
  felder: "M4 5h16v14H4zM4 10h16M4 15h16M10 5v14",
  karte: "M4 6h16v13H4zM8 10h5M8 14h8",
  blitz: "M13 3L5 13h6l-1 8 8-10h-6z",
  kontakte: "M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2.5 20a6.5 6.5 0 0113 0M16 4.6a3.5 3.5 0 010 6.3M18.5 14.2A6.5 6.5 0 0121.5 20",
  pause: "M8 5v14M16 5v14",
  anhang: "M20 11.5l-8.2 8.2a5 5 0 01-7.1-7.1l8.5-8.5a3.3 3.3 0 014.7 4.7l-8.5 8.4a1.7 1.7 0 01-2.4-2.4l7.8-7.8",
  play: "M8 5l11 7-11 7z",
  rueckgaengig: "M9 14L4 9l5-5M4 9h10a6 6 0 010 12h-3",
  glocke: "M6 9a6 6 0 0112 0c0 6 2.5 8 2.5 8h-17S6 15 6 9zM10 20.5a2.2 2.2 0 004 0",
} as const;

export type IconName = keyof typeof PFADE | "mehr";

interface Props extends SVGProps<SVGSVGElement> {
  name: IconName;
  groesse?: number;
}

export function Icon({ name, groesse = 18, ...rest }: Props) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {name === "mehr" ? (
        <g fill="currentColor" stroke="none">
          <circle cx="5" cy="12" r="1.7" />
          <circle cx="12" cy="12" r="1.7" />
          <circle cx="19" cy="12" r="1.7" />
        </g>
      ) : (
        <path d={PFADE[name]} />
      )}
    </svg>
  );
}

/** App-Logo: Globus aus dem Logo des B2B Förderzentrums. */
export function Logo({ groesse = 22 }: { groesse?: number }) {
  return <img className="nav__logo" src={globus} width={groesse} height={groesse} alt="" aria-hidden="true" />;
}
